
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 19","data-token-name":"heading-2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.941 15H7.78v-4.71H2.53V15H1.367V5.006H2.53v4.259h5.25v-4.26h1.162V15zm7.586 0h-5.613v-.815l2.291-2.326c.426-.43.783-.812 1.072-1.148.293-.336.516-.666.668-.99a2.52 2.52 0 00.229-1.078c0-.485-.145-.854-.434-1.108-.285-.258-.662-.387-1.13-.387-.41 0-.774.07-1.09.211-.317.141-.641.34-.973.598l-.522-.656a4.67 4.67 0 01.739-.51 3.695 3.695 0 011.845-.48c.528 0 .983.091 1.366.275.382.184.677.445.884.785.211.34.317.744.317 1.213 0 .453-.09.875-.27 1.266-.18.386-.431.771-.756 1.154a19.23 19.23 0 01-1.136 1.207l-1.864 1.857v.041h4.377V15z","fill":"currentColor"}})])
          )
        }
      }
    